module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    ref: "excel-upload-input",
    attrs: {
      "id": "excel-upload-input",
      "type": "file",
      "accept": ".xlsx, .xls"
    },
    on: {
      "change": _vm.handleClick
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "drop"
    },
    on: {
      "drop": _vm.handleDrop,
      "dragover": _vm.handleDragover,
      "dragenter": _vm.handleDragover
    }
  }, [_vm._v("\n    Drop excel file here or\n    "), _c('el-button', {
    staticStyle: {
      "margin-left": "16px"
    },
    attrs: {
      "loading": _vm.loading,
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.handleUpload
    }
  }, [_vm._v("Browse")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-392c4760"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/components/excel/index.vue
// module id = 1452
// module chunks = 1